import { render, staticRenderFns } from "./PartOfGov.vue?vue&type=template&id=69fb773a&scoped=true&"
import script from "./PartOfGov.vue?vue&type=script&lang=js&"
export * from "./PartOfGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fb773a",
  null
  
)

export default component.exports